var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBackspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 69,
    viewBox: "0 0 91 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.3333 4H28.3333C26.0333 4 24.2333 5.16667 23.0333 6.93333L5 34L23.0333 61.0333C24.2333 62.8 26.0333 64 28.3333 64H78.3333C82 64 85 61 85 57.3333V10.6667C85 7 82 4 78.3333 4ZM68.3333 45.9667L63.6333 50.6667L51.6667 38.7L39.7 50.6667L35 45.9667L46.9667 34L35 22.0333L39.7 17.3333L51.6667 29.3L63.6333 17.3333L68.3333 22.0333L56.3667 34L68.3333 45.9667Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackspace);
export default __webpack_public_path__ + "static/media/ic-backspace.2fffc65855a154877f36f3ce8222eca9.svg";
export { ForwardRef as ReactComponent };